var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSitem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "465px",
    height: "272px",
    viewBox: "0 0 465 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6 CISO and IT Risk Professionals") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-35.2%",
    y: "-40.8%",
    width: "170.4%",
    height: "181.0%",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workspace",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6-CISO-and-IT-Risk-Professionals",
    transform: "translate(-18.000000, -115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contract-Key-Term-Tracking-Graphic",
    fillRule: "nonzero",
    opacity: 0.304
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangles",
    transform: "translate(0.000000, 0.603786)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    points: "249.585305 209.283193 277.404487 167.358275 305.22367 209.283193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.444545,167.356867 L249.626065,209.281785 L277.444545,167.356867 Z M305.164637,209.281785 L277.346157,167.356867 L305.164637,209.281785 Z",
    id: "Shape",
    fill: "#B5BECB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.674,
    points: "277.301883 167.539884 305.121065 125.626228 332.939545 167.539884 332.939545 167.55185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.940248,167.515247 L277.301883,167.50328 L332.940248,167.515247 Z M305.164637,125.626228 L277.346157,167.53918 L305.164637,125.626228 Z M305.066952,125.614966 L305.066952,125.626932 L332.886134,167.540588 L305.066952,125.614966 Z",
    id: "Shape",
    fill: "#B5BECB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.618,
    points: "221.868727 84.0082156 249.687909 42.0952642 277.507092 84.0089195 277.507092 84.020886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.507092,83.9138916 L221.868727,83.9019251 L277.507092,83.9138916 Z M249.724453,42.0959682 L221.904568,84.0089195 L249.724453,42.0959682 Z M249.625363,42.0832978 L249.625363,42.0952642 L277.444545,84.0089195 L249.625363,42.0832978 Z",
    id: "Shape",
    fill: "#B5BECB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.618,
    points: "277.301883 84.0173665 305.121065 42.1037112 332.939545 84.0173665 332.939545 84.0293329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.940248,83.9216346 L277.301883,83.9096681 L332.940248,83.9216346 Z M305.164637,42.1030073 L277.346157,84.0166626 L305.164637,42.1030073 Z M305.066952,42.0945603 L305.066952,42.1065268 L332.886134,84.0201821 L305.066952,42.0945603 Z M360.450211,125.726184 L416.088576,125.73815 L360.450211,125.726184 Z M388.230038,167.546923 L416.048518,125.633268 L388.230038,167.546923 Z",
    id: "Shape",
    fill: "#B5BECB"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.315,
    points: "166.146732 167.708118 193.965915 209.633036 221.785097 167.708118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.618,
    points: "193.608204 125.73815 221.427387 83.8251989 249.246569 125.738854 249.246569 125.750821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#B5BECB",
    opacity: 0.618,
    points: "408.951235 125.73815 436.770418 83.8251989 464.5896 125.738854 464.5896 125.750821"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.618,
    points: "166.378646 84.0173665 194.197829 42.1037112 222.016309 84.0173665 222.016309 84.0293329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.362,
    points: "0.11572295 84.2510648 27.9349054 126.175983 55.7540879 84.2510648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.801965774,
    points: "139.33954 126.271715 111.520357 168.18537 83.7018774 126.271715 83.7018774 126.259748"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A9B2BF",
    opacity: 0.196,
    points: "222.031067 168.199448 249.850249 126.27453 277.669432 168.199448"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A9B2BF",
    points: "277.993409 0.371664819 250.174227 42.2853201 222.355044 0.371664819 222.355044 0.359698338"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-3",
    fill: "#A9B2BF",
    points: "388.868857 42.246605 361.049674 84.1602603 333.230492 42.246605 333.230492 42.2346385"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A9B2BF",
    opacity: 0.37,
    points: "138.986046 42.2606832 166.805228 0.347027947 194.624411 42.2606832 194.624411 42.2754654"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.238,
    points: "137.411839 125.745893 165.231022 83.832238 193.049501 125.745893 193.049501 125.75786"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5BECB",
    opacity: 0.403,
    points: "55.6606194 84.0173665 83.4798018 42.1037112 111.298282 84.0173665 111.298282 84.0293329"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "business-initiative",
    filter: "url(#filter-1)",
    transform: "translate(110.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,113.131313 L28,14.1414141 C28,6.33181818 34.3318182,-1.42108547e-14 42.1414141,-1.42108547e-14 L183.555556,-1.42108547e-14 C191.365152,-1.42108547e-14 197.69697,6.33181818 197.69697,14.1414141 L197.69697,113.131313 L28,113.131313 Z",
    id: "Path",
    stroke: "#30383B",
    strokeWidth: 6.06060606,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.989899,113 C225.989899,127.103886 215.664212,138.79787 202.160668,140.934121 L201.976543,141.626262 L28.2828283,141.626262 C12.6636364,141.626262 -2.7000624e-13,128.962626 -2.7000624e-13,113.343435 L-2.7000624e-13,113.343435 L127,113.343 L127,113 L225.989899,113 Z",
    id: "Combined-Shape",
    stroke: "#30383B",
    strokeWidth: 6.06060606,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.979798,148.484848 C204.979798,146.929293 204.831313,145.409091 204.615656,143.913636 L216.501515,131.628283 L209.430808,119.381818 L192.864141,123.528788 C190.470707,121.637374 187.801515,120.085353 184.923738,118.939899 L180.232323,102.525253 L166.090909,102.525253 L161.40303,118.939899 C158.525253,120.085353 155.856061,121.637374 153.462626,123.528788 L136.895959,119.381818 L129.825253,131.628283 L141.711111,143.913636 C141.491919,145.409091 141.343435,146.929293 141.343435,148.484848 C141.343435,150.040404 141.491919,151.560606 141.707576,153.056061 L129.821717,165.341414 L136.892424,177.587879 L153.459091,173.440909 C155.852525,175.332323 158.521717,176.884344 161.399495,178.029798 L166.090909,194.444444 L180.232323,194.444444 L184.920202,178.029798 C187.79798,176.884344 190.467172,175.332323 192.860606,173.440909 L209.427273,177.587879 L216.49798,165.341414 L204.612121,153.056061 C204.831313,151.560606 204.979798,150.040404 204.979798,148.484848 Z",
    id: "Path",
    stroke: "#3D4543",
    strokeWidth: 6.06060606,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#30383B",
    strokeWidth: 6.06060606,
    cx: 173.161616,
    cy: 148.484848,
    r: 10.6060606
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.00128,39.5845887 C132.28473,39.5794507 134.390265,37.5014347 134.454263,35.4502979 C134.52914,33.046532 132.330168,30.9960352 130.063998,30.9813156 C127.436879,30.9640361 125.509898,33.1066901 125.658374,35.1667866 C125.391502,37.4412765 127.648072,39.5896903 130.00128,39.5845887 Z M148.49543,33.1252495 C149.162097,33.8373343 149.49543,34.549419 149.49543,35.2615037 C149.49543,35.9735884 149.162097,36.6856732 148.49543,37.3977579 L147.669856,37.3977579 C144.806584,37.3977579 141.943312,37.4163173 139.08132,37.3830383 C138.519417,37.3766385 138.278785,37.5718325 138.11559,38.076777 C137.12618,41.1429225 134.86705,42.7761522 131.832264,43.3636541 C128.402609,44.0273136 125.418381,43.0782228 123.118292,40.4031053 C122.385515,39.5500116 121.90105,38.4825245 121.220751,37.3798384 L76.0157435,37.3798384 C75.3490768,36.6765001 75.0157435,35.9731618 75.0157435,35.2698235 C75.0157435,34.5664851 75.3490768,33.8631468 76.0157435,33.1598085 L121.163792,33.1598085 C122.054645,31.8619285 122.728544,30.612047 123.657155,29.5944783 C124.956955,28.1698822 126.674662,27.4243052 128.608043,27.1254344 C131.045728,26.7472061 133.25494,27.2150317 135.247838,28.6556273 C136.563638,29.606638 137.617045,30.7803618 138.088071,32.3758326 C138.255746,32.9422152 138.524537,33.1534087 139.156198,33.143809 C141.966991,33.1002903 144.779065,33.1252495 147.591138,33.1252495 L148.49543,33.1252495 Z",
    id: "Fill-11",
    fill: "#30383B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.224643,81.432305 C138.147845,78.801986 136.174146,77.1578767 133.691022,77.1745162 C131.193819,77.1905157 129.417874,78.8711039 129.312917,81.3913462 C129.23164,83.346486 131.348694,85.8180898 133.727501,85.5883369 C136.05063,85.7246527 138.287361,83.5640793 138.224643,81.432305 Z M76,83.2652085 C75.3333333,82.6042155 75,81.9432226 75,81.2822296 C75,80.6212366 75.3333333,79.9602437 76,79.2992507 L76.9862096,79.2992507 C92.7834828,79.2992507 108.582036,79.2973308 124.379949,79.3062905 C124.899613,79.3069305 125.179925,79.2410125 125.423117,78.6471108 C126.688358,75.5675257 128.945568,73.6949434 132.298425,73.1452003 C135.0689,72.6908143 137.496345,73.4056723 139.628759,75.1208195 C140.678327,75.9649534 141.389345,77.1220378 141.777173,78.4352773 C141.962767,79.061178 142.241159,79.3568489 142.989296,79.3242099 C144.79596,79.2467723 146.609024,79.2992507 148.466887,79.2992507 C149.133554,80.1805747 149.466887,80.8415676 149.466887,81.2822296 C149.466887,81.7228916 149.133554,82.3838845 148.466887,83.2652085 L147.747549,83.2652085 C146.060561,83.2652085 144.372933,83.279928 142.685945,83.2549688 C142.268038,83.249849 142.033805,83.3592856 141.917969,83.7759128 C141.322147,85.9262465 140.009548,87.5434767 138.052488,88.5584854 C136.271423,89.4819769 134.355962,89.7597284 132.335544,89.447418 C130.371445,89.1447073 128.635818,88.3863307 127.321299,86.9310155 C126.531563,86.0555225 125.930621,84.9707559 125.424397,83.8949491 C125.174165,83.3631255 124.939932,83.2556088 124.438187,83.2575287 C121.217807,83.2722483 117.996786,83.2652085 114.775765,83.2652085 L76.9682902,83.2652085 L76,83.2652085 Z",
    id: "Fill-13",
    fill: "#30383B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4054157,53.9501438 C91.2243629,53.978303 88.8756352,55.6915302 88.9345134,58.2213722 C88.9927516,60.7160153 90.830775,62.349885 93.3202983,62.3934037 C96.0722135,62.4420422 97.9134367,60.1771519 97.7598415,58.2348118 C98.0171135,56.1164771 95.5986281,53.9213447 93.4054157,53.9501438 Z M75.001152,58.2575311 C75.001152,57.6012313 75.3344853,56.9449315 76.001152,56.2886318 L76.8356862,56.2886318 C79.3405691,56.2886318 81.8454519,56.2828719 84.3509747,56.2937516 C84.8239201,56.2956716 85.0331936,56.2188739 85.2315875,55.6550513 C86.3419533,52.4986686 88.6017237,50.6753647 91.9283412,50.1416212 C94.3621862,49.7499533 96.574598,50.2203388 98.5706965,51.6558145 C100.157208,52.7968994 101.254134,54.2829336 101.641322,56.2841519 L148.463559,56.2841519 C149.130226,56.9458915 149.463559,57.6076311 149.463559,58.2693707 C149.463559,58.9311103 149.130226,59.59285 148.463559,60.2545896 L147.529188,60.2545896 C132.549809,60.2545896 117.570431,60.2590694 102.591053,60.24179 C101.942753,60.24051 101.639402,60.3953852 101.401329,61.051365 C100.330642,64.0138337 98.1463896,65.7673797 95.1013634,66.3785609 C91.9225813,67.0159812 89.1284274,66.1558477 86.9454547,63.7412021 C86.2069175,62.9258672 85.6654942,61.8833394 85.2354274,60.8606509 C85.0274338,60.3678661 84.8610389,60.2481898 84.404093,60.2494697 C81.7712142,60.2603494 79.1376953,60.2552295 76.5054564,60.2533096 C76.357621,60.2533096 76.2091456,60.2379501 76.001152,60.2264304 C75.3344853,59.5701307 75.001152,58.9138309 75.001152,58.2575311 Z",
    id: "Fill-15",
    fill: "#30383B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.658374,35.1667866 C125.509898,33.1066901 127.436879,30.9640361 130.063998,30.9813156 C132.330168,30.9960352 134.52914,33.046532 134.454263,35.4502979 C134.390265,37.5014347 132.28473,39.5794507 130.00128,39.5845796 C127.648072,39.5896903 125.391502,37.4412765 125.658374,35.1667866",
    id: "Fill-17",
    fill: "#00BBB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.727501,85.5883369 C131.348694,85.8180898 129.23164,83.346486 129.312917,81.3913462 C129.417874,78.8711039 131.193819,77.1905157 133.691022,77.1745162 C136.174146,77.1578767 138.147845,78.801986 138.224643,81.432305 C138.287361,83.5640793 136.05063,85.7246527 133.727501,85.5883369",
    id: "Fill-19",
    fill: "#00BBB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7598415,58.2348118 C97.9134367,60.1771519 96.0722135,62.4420422 93.3202983,62.3934037 C90.830775,62.349885 88.9927516,60.7160153 88.9345134,58.2213722 C88.8756352,55.6915302 91.2243629,53.978303 93.4054157,53.9501438 C95.5986281,53.9213447 98.0171135,56.1164771 97.7598415,58.2348118",
    id: "Fill-21",
    fill: "#00BBB4"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitem);
export default __webpack_public_path__ + "static/media/sitem.15e514d342f49b0dae956efbb81e3671.svg";
export { ForwardRef as ReactComponent };